module.exports = __webpack_public_path__ + "img/logo144.b31f9e1d.png";